import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { SecureRoute } from "@okta/okta-react";
import { withOktaAuth } from "@okta/okta-react";
import {
  ChecksRequestContainer,
  RecordsContainer,
  AdminContainer,
} from "../../Container";

import { AppBar, LoadingIndicator, Footer } from "../../Component";
import withUserDetails from "../../HOC/withUserDetails";

const Home = (props) => {
  const {
    authState,
    getUserInfo,
    getUserPermissions,
    hasPermission,
    hasRecordPermission,
    hasAnyRecordPermission,
    logout,
  } = props;
  const [user, setUser] = useState();
  const [userPermissions, setUserPermissions] = useState();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadUserDetails = async () => {
      const user = await getUserInfo();
      const userPermissions = await getUserPermissions();
      setUser(user);
      setUserPermissions(userPermissions);
      setIsLoaded(true);
    };
    loadUserDetails();
  }, []);

  if (!authState.isAuthenticated || !isLoaded) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <Router basename="/glc">
      <AppBar
        user={user}
        userPermissions={userPermissions}
        hasPermission={hasPermission}
        hasAnyRecordPermission={hasAnyRecordPermission}
        logout={logout}
      />
      <Switch>
        <SecureRoute
          path="/checks"
          component={() => (
            <ChecksRequestContainer
              user={user}
              userPermissions={userPermissions}
              hasPermission={hasPermission}
              hasRecordPermission={hasRecordPermission}
            />
          )}
        />
        <SecureRoute
          path="/records"
          component={() => (
            <RecordsContainer
              user={user}
              userPermissions={userPermissions}
              hasPermission={hasPermission}
              hasRecordPermission={hasRecordPermission}
            />
          )}
        />
        <SecureRoute
          path="/admin"
          component={() => (
            <AdminContainer
              user={user}
              userPermissions={userPermissions}
              hasPermission={hasPermission}
              hasRecordPermission={hasRecordPermission}
              hasAnyRecordPermission={hasAnyRecordPermission}
            />
          )}
        />
        <Redirect to="/checks" />
      </Switch>
      <Footer />
    </Router>
  );
};

export default withUserDetails(withOktaAuth(Home));
